import { useCallback, useEffect, useState } from "react";
import { FileSearch, RefreshCw } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { IngestionReportDialog } from "@/components/admin/IngestionReportDialog";

// Platform Super Admin: pick any document across tenants and open its read-only Ingestion Verification Report.
export function IngestionReports() {
  const [docs, setDocs] = useState([]);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(null);

  const load = useCallback(async () => {
    setBusy(true);
    try { const { data } = await api.get("/platform/documents", { params: { q } }); setDocs(data); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  }, [q]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="sc-card p-5" data-testid="ingestion-reports-card">
      <div className="flex items-center justify-between mb-3">
        <div className="label-cap">Ingestion verification reports</div>
        <div className="flex items-center gap-2">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by document name…" className="sc-input text-xs w-64" data-testid="ingestion-doc-filter" />
          <button onClick={load} className="border border-slate-700 hover:border-amber-500 px-2 py-1.5 rounded-md text-xs inline-flex items-center gap-1" data-testid="ingestion-refresh-button"><RefreshCw className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} /></button>
        </div>
      </div>
      <table className="sc-table w-full text-xs"><thead><tr><th>Document</th><th>Project</th><th>Company</th><th>Status</th><th>Pages</th><th>Size</th><th>Uploaded</th><th></th></tr></thead>
        <tbody>{docs.map((d) => (
          <tr key={d.id} data-testid={`ingestion-doc-row-${d.id}`}>
            <td className="text-slate-100">{d.name}</td><td>{d.project_name || "—"}</td><td>{d.workspace_name || "—"}</td>
            <td className={`font-mono ${d.status === "ready" ? "text-emerald-400" : d.status === "failed" ? "text-red-400" : "text-amber-400"}`}>{d.status}{d.status !== "ready" && d.stage ? ` · ${d.stage}` : ""}</td>
            <td className="font-mono">{d.page_count ?? "—"}</td><td className="font-mono">{d.file_size ? `${(d.file_size / 1048576).toFixed(1)} MB` : "—"}</td>
            <td className="font-mono text-slate-500">{d.created_at ? new Date(d.created_at).toLocaleDateString() : ""}</td>
            <td className="text-right"><button onClick={() => setOpen(d)} className="inline-flex items-center gap-1 border border-slate-700 hover:border-amber-500 hover:text-amber-300 rounded px-2 py-1" data-testid={`ingestion-report-button-${d.id}`}><FileSearch className="w-3.5 h-3.5" /> Ingestion report</button></td>
          </tr>
        ))}</tbody></table>
      {!docs.length && <div className="text-slate-500 text-xs py-4">No documents match.</div>}
      {open && <IngestionReportDialog doc={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
